import * as React from 'react';
import { BuildJsonType, EnhancedAppointment } from '@bb/domain/dist/types';

type NewAppointmentAlertProps = {
  appointment: BuildJsonType<EnhancedAppointment>;
};

const NewAppointmentAlert: React.FunctionComponent<
  NewAppointmentAlertProps
> = ({ appointment }) => {
  if (appointment.status === 'confirm') {
    return (
      <p className="alert alert-success" style={{ margin: 0 }}>
        Your showing is confirmed automatically! Please refer to the
        confirmation email sent to
        <strong> {appointment.coop.email} </strong>
        for further management of the showing.
      </p>
    );
  }

  if (appointment.status === 'new') {
    return (
      <p
        className="alert alert-success"
        style={{ margin: 0 }}
        data-cy="appointment-message-new"
      >
        Thank you for booking a showing through BrokerBay! Your showing request
        is being processed.
      </p>
    );
  }

  return null;
};

export default NewAppointmentAlert;
